import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"

    const showLabel = this.buttonTarget.dataset.showLabel
    const hideLabel = this.buttonTarget.dataset.hideLabel
    if (showLabel && hideLabel) {
      this.buttonTarget.textContent = isPassword ? hideLabel : showLabel
    } else {
      this.buttonTarget.textContent = isPassword ? "Ocultar" : "Mostrar"
    }
  }
}
